"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledProgressBar = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ProgressBarMixin = require("../../mixins/components/ProgressBarMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledProgressBar = /*#__PURE__*/(0, _styledComponents.default)('div').withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['size', 'value', 'orientation'])
}).withConfig({
  displayName: "StyledProgressBar",
  componentId: "c11n-8-107-0__sc-1ut6l7a-0"
})(["", ""], _ProgressBarMixin.ProgressBarMixin);
exports.StyledProgressBar = StyledProgressBar;